import React, { ChangeEvent, FC, useRef } from 'react';
import { RedoOutlined } from '@ant-design/icons';
import { message } from 'antd';
import { FileRequestType } from '../../../../../types';
import { ButtonUI, FileInputUI } from './styled';

export type FileNode = {
  title: string;
  base64: string;
  filePath: string;
};

export type FileEditorData = {
  data: string;
  name: string;
  type: string;
};

type FileEditorProps = {
  onChange: (data: FileEditorData) => void;
  onClear?: () => void;
  value?: FileRequestType;
  label?: string;
  formats?: string[];
  fileSize?: number;
};

export const UploadComponent: FC<FileEditorProps> = ({ fileSize = 1100000000, onChange, formats, onClear, value }) => {
  const inputRef = useRef<HTMLInputElement>(null);

  const onChangeFileHandler = (event: ChangeEvent<HTMLInputElement>) => {
    const element = event.target;
    const file = element.files && element.files[0];

    if (file) {
      if (file.size < fileSize) {
        const fileReader = new FileReader();

        const { name, type } = file;
        fileReader.onload = () => {
          const requestData = { data: fileReader.result as string, name, type };
          onChange(requestData);
        };

        fileReader.readAsDataURL(file);
      } else {
        message.warning(`Размер файла превышает ${fileSize ? fileSize / 1100000000 : '1'}гб`);
      }

      element.value = '';
    }
  };

  return (
    <div>
      <FileInputUI>
        <input
          type="file"
          ref={inputRef}
          onChange={onChangeFileHandler}
          style={{ display: 'none' }}
          accept={formats?.join(',')}
        />
        {value && (
          <button type="button" className="remove-button" onClick={onClear}>
            +
          </button>
        )}
        <ButtonUI
          type="button"
          onClick={() => {
            inputRef.current?.click();
          }}
        >
          {value ? (
            <>
              <RedoOutlined /> {value.title}
            </>
          ) : (
            'Загрузить файл'
          )}
        </ButtonUI>
      </FileInputUI>
    </div>
  );
};
